import { partyType, countries, usStates, bondType, contactTypeOption } from './options'

const active = [
  { value: true, description: 'Active' },
  { value: false, description: 'Inactive' }
]

const importerConsignee = [
  { value: true, description: 'Yes' },
  { value: false, description: 'No' }
]

const header = [
  {
    name: 'partyMasterName',
    label: 'Profile Name',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined
  },
    {
    name: 'active',
    label: 'Status',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    requiredCondition: (formData) => formData.partyCode === 'IM',
    disabled: false,
    icon: undefined
  },
  {
    name: 'partyNumber',
    label: 'Party Number',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'partyNumberType',
    label: 'Party Number Type',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    type: 'new'
  },
  {
    name: 'partyCode',
    label: 'Party Type',
    type: 'auto',
    maxLength: 20,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined
  },
  {
    name: 'name',
    label: 'Company Name',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined
  },
    {
    name: 'taxIdNumber',
    label: 'Tax id Number',
    type: 'Text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    requiredCondition: (formData) => formData.partyCode === 'IM',
    disabled: false,
    icon: undefined
  },
  {
    name: 'duns',
    label: 'DUNS Number',
    type: 'text',
    maxLength: 20,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
    {
    name: 'address1',
    label: 'Address 1',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    requiredCondition: (formData) => formData.partyCode === 'IM',
    disabled: false,
    icon: undefined
  },
  {
    name: 'address2',
    label: 'Address 2',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'apartmentSuiteNumber',
    label: 'Apartment/Suite Number',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    type: 'new'
  },
    {
    name: 'city',
    label: 'City',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    requiredCondition: (formData) => formData.partyCode === 'IM',
    disabled: false,
    icon: undefined
  },
    {
    name: 'stateProvince',
    label: 'State/Province',
    type: 'auto',
    maxLength: 4,
    placeholder: '',
    defaultValue: '',
    required: false,
    requiredCondition: (formData) => formData.partyCode === 'IM',
    disabled: false,
    icon: undefined
  },
    {
    name: 'postalCode',
    label: 'Postal Code',
    type: 'text',
    maxLength: 6,
    placeholder: '',
    defaultValue: '',
    required: false,
    requiredCondition: (formData) => formData.partyCode === 'IM',
    disabled: false,
    icon: undefined
  },
    {
    name: 'countryCode',
    label: 'Country',
    type: 'auto',
    maxLength: 20,
    placeholder: '',
    defaultValue: '',
    required: false,
    requiredCondition: (formData) => formData.partyCode === 'IM',
    disabled: false,
    icon: undefined
  },
]

const contact = [
  {
    name: 'contactType',
    label: 'Contact Type',
    type: 'auto',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'contactName',
    label: 'Contact Name',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'contactTelephone',
    label: 'Contact Telephone',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'contactEmail',
    label: 'Contact Email',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  }
]

const importerInformation = [
    {
    name: 'bondType',
    label: 'Bond Type',
    type: 'auto',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined
  },
    {
    name: 'suretyCode',
    label: 'Surety Code',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined
  },
  {
    name: 'bondAmount',
    label: 'Bond Amount',
    type: 'text',
    maxLength: 20,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'bondNumber',
    label: 'Bond Number',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'bondExpirationDate',
    label: 'Bond Expiration Date',
    type: 'Date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'importerConsignee',
    label: 'Use Importer as Consignee',
    type: 'auto description',
    maxLength: 20,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  }
]

const optionsMap = {
  active: active,
  partyCode: partyType,
  countryCode: countries,
  stateProvince: usStates,
  bondType: bondType,
  contactType: contactTypeOption,
  importerConsignee: importerConsignee
}

export { header, optionsMap, contact, importerInformation }
